<div id="adfs-saml2-login">
  <app-loading-spinner></app-loading-spinner>
</div>
